export default __webpack_public_path__ + "static/media/Math1.f8caa943.pdf";